import { Component, Inject, OnInit } from '@angular/core';
import { OrderTableComponent } from '../order-table/order-table.component';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { Cart } from '../../../payments/payment/interfaces/payment-summary.interface';
import { AmountPipe } from '../../../payments/payment/pipes/amount.pipe';
import { TimestampPipe } from '../../../payments/payment/pipes/timestamp.pipe';

@Component({
  standalone: true,
  imports: [
    MatDialogContent,
    CommonModule,
    OrderTableComponent,
    AmountPipe,
    TimestampPipe
  ],
  selector: 'equine-ui-nx-cart-details-dialog',
  templateUrl: './cart-details-dialog.component.html',
  styleUrls: ['./cart-details-dialog.component.scss']
})
export class CartDetailsDialogComponent implements OnInit {

  public cart!: Cart;
  public paid = 0;

  constructor(
    public dialogRef: MatDialogRef<CartDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    this.cart = this.data;
    if (this.cart && this.cart.orders.length) {
      this.paid = this.cart.orders[0].paid || 0;
    }
  }

}
